import { inject, Injectable } from '@angular/core';
import { BuildingService } from './application/flexseat/building.service';
import { ReservationService } from './application/flexseat/reservation.service';
import { DateService } from './application/util/date/date.service';
import { GraphService } from './application/util/graph/graph.service';
import { AuthService } from './application/util/oauth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class StartupService {

  private readonly graphService = inject(GraphService);
  private readonly reservationService = inject(ReservationService);
  private readonly buildingService = inject(BuildingService);
  private readonly dateService = inject(DateService);
  private readonly authService = inject(AuthService);

  public async initializeServices() {
   
    await this.graphService.saveGraphUserData();
    await this.buildingService.fetchBuildings(this.graphService.userGraphData()!.department, this.graphService.userGraphData()!.employeeId);
    await this.reservationService.fetchUserReservations(this.graphService.userGraphData()!.employeeId);
    
  }

}
